export enum BlockUiType {
    block = 1,
    network = 2,
}
